import { Dispatch } from "redux";
import { setScreens } from './reducer'

export const getScreens = () => async (dispatch: Dispatch) => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/screen`
        const res = await fetch(url, {
            credentials: 'include'
        });

        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }

        dispatch(setScreens((await res.json()).data))
        return true;
    } catch (err: any) {
        console.error('Error fetching screens:', err);
        return [];
    }
}
